import { render, staticRenderFns } from "./ArchiveStockClosingModal.vue?vue&type=template&id=6505de38&"
import script from "./ArchiveStockClosingModal.vue?vue&type=script&lang=js&"
export * from "./ArchiveStockClosingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchiveStockClosingModal.vue"
export default component.exports